export function safeParseInt(value: string | number | null | undefined, defaultValue?: number): number | undefined {
	// Value is undefined
	if (value === undefined || value === null) {
		return defaultValue;
	}

	let parsed: number | undefined;

	// Attempt to parse
	try {
		// Value is already a number
		if (typeof value === 'number') {
			// Mimic the value of parseInt and round down
			parsed = Math.floor(value);
		} else {
			parsed = Number.parseInt(value, 10);
		}
	} catch {
		parsed = undefined;
	}

	// Set to undefined if the value isn't a number
	if (Number.isNaN(parsed)) {
		parsed = undefined;
	}

	// Return the parsed value or default value
	return parsed ?? defaultValue;
}
